import { arrayMove } from '@dnd-kit/sortable'

import { type SequenceStep, SequenceStepStatus } from '@/models/sequence'

export interface ReorderResult {
  items: SequenceStep[]
  pendingIds: string[]
}

function pendingIds(items: SequenceStep[]): string[] {
  return items.filter((s) => s.status === SequenceStepStatus.PENDING).map((s) => s.id)
}

/** Move `activeId` to `overId`'s slot; return the new full order + the PENDING-only
 * id order (completed steps are never reordered, so they're excluded from the payload). */
export function reorderSteps(items: SequenceStep[], activeId: string, overId: string): ReorderResult {
  if (activeId === overId) return { items, pendingIds: pendingIds(items) }
  const oldIdx = items.findIndex((s) => s.id === activeId)
  const newIdx = items.findIndex((s) => s.id === overId)
  if (oldIdx === -1 || newIdx === -1) {
    return { items, pendingIds: pendingIds(items) }
  }
  const next = arrayMove(items, oldIdx, newIdx)
  return { items: next, pendingIds: pendingIds(next) }
}
